// extracted by mini-css-extract-plugin
export default {"center":"LeafletForm_center__9fBRc","centerdiv":"LeafletForm_centerdiv__wNk+u","error":"LeafletForm_error__rP4ey","centerdivresized":"LeafletForm_centerdivresized__JJ9J1"};